import * as React from 'react';

export const UnifiedPressSystemEnableContext = React.createContext(false);

export function useIsUnifiedPressSystemEnabledEvents(): boolean {
  return React.useContext(UnifiedPressSystemEnableContext);
}
